import { Row, UseRowSelectInstanceProps } from 'react-table'
import { Data } from '@amzn/aapn-react-components/dist/Table/table'
import React from 'react'
import { Checkbox, useUID } from '@amzn/storm-ui'

// Adapted from: https://github.com/TanStack/table/issues/2988#issuecomment-861506888

export interface CheckAllHeaderProps extends UseRowSelectInstanceProps<Data> {
  rows: Row[]
  hasRefinementsSet: boolean
}

export const ManageAdvertisersCheckAllHeader: React.FunctionComponent<CheckAllHeaderProps> = (props: CheckAllHeaderProps): JSX.Element => {
  const allRowsDisabled = props.rows.filter((row) => (row.original as { disabled?: boolean }).disabled).length === props.rows.length
  const allSelectableRowsCount = props.rows.length - props.rows.filter((row) => (row.original as { disabled?: boolean }).disabled).length
  const checked: boolean = props.selectedFlatRows.length > 0 && props.selectedFlatRows.length === allSelectableRowsCount
  const indeterminate: boolean = !checked && props.selectedFlatRows.length > 0
  const disabled: boolean = (props.rows.length === 0 || allRowsDisabled) && !props.hasRefinementsSet
  const overriddenOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    props.rows.forEach((row) => !(row.original as { disabled?: boolean }).disabled && props.toggleRowSelected(row.id, event.currentTarget.checked))
  }

  const modifiedToggleAllRowsProps = {
    ...props.getToggleAllRowsSelectedProps(),
    onChange: overriddenOnChange,
    checked: checked,
    indeterminate: indeterminate,
    disabled: disabled,
  }

  return <Checkbox id={useUID('check-all-header-checkbox')} label={''} {...modifiedToggleAllRowsProps} />
}
